import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import {
  Invoice,
  InvoiceBody,
  InvoiceListResponse,
  Order,
} from "@lib/types/Billing";

// Invoice
export const apiAddInvoice = async (data: InvoiceBody) => {
  return API.post<Invoice>(`/billing-invoice`, data);
};

export const apiUpdateInvoice = async (data: InvoiceBody) => {
  const { id, ...rest } = data;
  return API.patch<Invoice>(`/billing-invoice/${id}`, rest);
};

export const apiDeleteInvoice = async (data: Invoice) => {
  return API.delete<null>(`/billing-invoice/${data.id}`);
};

export const apiGetInvoice = async <T extends ApiParams>(
  id: string,
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/billing-invoice/${id}` });
  return API.get<Invoice>(url);
};

export const apiGetInvoices = async <T extends ApiParams<Invoice>>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/billing-invoice` });
  return API.get<InvoiceListResponse>(url);
};

// Order
export const apiAddOrder = async (data: Order) => {
  return API.post<Order>(`/billing-order`, data);
};

export const apiDeleteOrder = async (data: Order) => {
  return API.delete<null>(`/billing-order/${data.id}`);
};

export const apiUpdateOrder = async (data: Partial<Order>) => {
  const { id, ...rest } = data;
  return API.patch<Order>(`/billing-order/${id}`, rest);
};

export const apiGetOrders = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/billing-order` });
  return API.get<PaginationType<Order>>(url);
};
